// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"02bccda3","237":"e62563f7","289":"2c09fbe1","318":"ed2387f1","322":"9564c01f","356":"173d0ad0","382":"ce27e87f","465":"e9cd76ed","495":"da4c5639","600":"d9560f72","834":"6cc0357e","850":"92e7ea74","882":"c205998a","956":"9da0e3a6"}[chunkId] + ".chunk.js";
};